// Footer "Locations & Cities" directory — replicated from the LIVE site
// footer (tablespace.com): city -> micro-market -> centres. Centre links
// point to the internal /locations/<city>/<centre> pages (all 74 replicated
// on this site and editable in /admin/locations); the live
// /office-space-in-* URLs also redirect there via next.config.mjs.
export type FooterCentre = { name: string; href: string };
export type FooterMarket = { name: string; centres: FooterCentre[] };
export type FooterCity = { name: string; markets: FooterMarket[] };

export const footerLocations: FooterCity[] = [
  {
    name: "Bengaluru",
    markets: [
      {
        name: "Outer Ring Road",
        centres: [
          { name: "Table Space Bagmane Luxor", href: "/locations/bengaluru/bagmane-luxor" },
          { name: "Table Space Embassy Onyx", href: "/locations/bengaluru/embassy-onyx" },
          { name: "Table Space Gopalan Fortune City", href: "/locations/bengaluru/gopalan-fortune-city" },
          { name: "Table Space Manyata Embassy Business Park (L6)", href: "/locations/bengaluru/manyata-embassy-business-park-l6" },
          { name: "Table Space MFAR Manyata Greenheart 2B", href: "/locations/bengaluru/mfar-manyata-tech-park" },
          { name: "Table Space Prestige Tech Park (Valence)", href: "/locations/bengaluru/valence-ptp" },
          { name: "Table Space Zonasha Frontier", href: "/locations/bengaluru/zonasha-frontier" },
        ],
      },
      {
        name: "Whitefield",
        centres: [
          { name: "Table Space Towers Whitefield", href: "/locations/bengaluru/ts-towers-whitefield" },
          { name: "Table Space International Tech Park Limited (ITPL)", href: "/locations/bengaluru/itpl" },
          { name: "Table Space Prestige Shantiniketan", href: "/locations/bengaluru/prestige-shantiniketan" },
          { name: "Table Space Bagmane Solarium", href: "/locations/bengaluru/bagmane-solarium" },
          { name: "Table Space Prestige Tech Park (Etamin)", href: "/locations/bengaluru/exora-etamin" },
          { name: "Table Space SJR PrimeCo Union City", href: "/locations/bengaluru/sjr-union-city" },
        ],
      },
      {
        name: "Koramangala",
        centres: [
          { name: "Table Space Bren Optimus", href: "/locations/bengaluru/bren-optimus" },
        ],
      },
      {
        name: "Indiranagar",
        centres: [
          { name: "Table Space DivyaSree Greens", href: "/locations/bengaluru/divyasree-greens" },
          { name: "Table Space Godrej Center Indiranagar", href: "/locations/bengaluru/godrej-indiranagar" },
          { name: "Table Space Embassy Golf Links", href: "/locations/bengaluru/egl" },
          { name: "Table Space Vaswani Augusta", href: "/locations/bengaluru/vaswani-augusta" },
          { name: "Table Space Vaswani Oakmont", href: "/locations/bengaluru/vaswani-oakmont" },
        ],
      },
      {
        name: "Central Business District",
        centres: [
          { name: "Table Space Towers Vittal Mallya Road", href: "/locations/bengaluru/ts-towers-vmr" },
          { name: "Table Space Prestige Trade Towers", href: "/locations/bengaluru/prestige-trade-towers" },
          { name: "Table Space Sobha 1", href: "/locations/bengaluru/sobha-1" },
          { name: "Table Space UB City", href: "/locations/bengaluru/ub-city" },
          { name: "Table Space Prestige Obelisk", href: "/locations/bengaluru/prestige-obelisk" },
          { name: "Table Space RMZ Millenia", href: "/locations/bengaluru/rmz-millenia" },
          { name: "Table Space Prestige Khoday Tower", href: "/locations/bengaluru/prestige-khoday-tower" },
          { name: "Table Space Vaswani Centropolis", href: "/locations/bengaluru/vaswani-centropolis" },
        ],
      },
      {
        name: "Bannerghatta",
        centres: [
          { name: "Table Space SJR PrimeCo Towers", href: "/locations/bengaluru/sjr-prime" },
        ],
      },
      {
        name: "Ulsoor Road",
        centres: [
          { name: "Table Space Senate", href: "/locations/bengaluru/table-space-senate" },
        ],
      },
      {
        name: "North Bengaluru",
        centres: [
          { name: "Table Space MFAR 2B Embassy Manyata Business Park", href: "/locations/bengaluru/mfar-2b-embassy-manyata-business-park" },
        ],
      },
    ],
  },
  {
    name: "Hyderabad",
    markets: [
      {
        name: "Gachibowli",
        centres: [
          { name: "Table Space Phoenix Centaurus", href: "/locations/hyderabad/pheonix-centaurus" },
        ],
      },
      {
        name: "HITEC City",
        centres: [
          { name: "Table Space KRC Raheja Mindspace", href: "/locations/hyderabad/mindspace-building-4" },
          { name: "Table Space Aurobindo Galaxy", href: "/locations/hyderabad/aurobindo-galaxy" },
          { name: "Table Space My Home Twitza", href: "/locations/hyderabad/my-home-twitza" },
        ],
      },
      {
        name: "Madhapur",
        centres: [
          { name: "Table Space Jyothi Galaxy", href: "/locations/hyderabad/jyothi-galaxy" },
        ],
      },
      {
        name: "Nanakramguda",
        centres: [
          { name: "Table Space Sohini Tech Park", href: "/locations/hyderabad/sohini-tech-park" },
        ],
      },
    ],
  },
  {
    name: "Noida",
    markets: [
      {
        name: "Sector 143 A",
        centres: [
          { name: "Table Space DLF Tech Park", href: "/locations/noida/dlf-tech-park" },
        ],
      },
      {
        name: "Sector 94",
        centres: [
          { name: "Table Space BPTP Capital City", href: "/locations/noida/bptp" },
        ],
      },
    ],
  },
  {
    name: "Gurugram",
    markets: [
      {
        name: "Cyber City",
        centres: [
          { name: "Table Space DLF Cyber Greens", href: "/locations/gurugram/dlf-cyber-greens" },
          { name: "Table Space DLF Building 10", href: "/locations/gurugram/dlf-building-10" },
          { name: "Table Space DLF Building 6", href: "/locations/gurugram/dlf-building-6" },
          { name: "Table Space DLF Building 8", href: "/locations/gurugram/dlf-building-8" },
        ],
      },
      {
        name: "DLF City Phase 3",
        centres: [
          { name: "Table Space DLF Downtown", href: "/locations/gurugram/dlf-downtown-4" },
        ],
      },
      {
        name: "Golf Course Road",
        centres: [
          { name: "Table Space Godrej GCR", href: "/locations/gurugram/godrej-gcr" },
          { name: "Table Space DLF Two Horizon Center", href: "/locations/gurugram/dlf-two-horizon-center" },
        ],
      },
      {
        name: "DLF Cybercity",
        centres: [
          { name: "Table Space Atrium Place", href: "/locations/gurugram/atrium-place" },
        ],
      },
      {
        name: "Udyog Vihar",
        centres: [
          { name: "Table Space Global Gateway", href: "/locations/gurugram/global-gateway" },
        ],
      },
      {
        name: "Golf Course Extension Road",
        centres: [
          { name: "Table Space Good Earth Business Bay II", href: "/locations/gurugram/good-earth-business-bay-ii" },
        ],
      },
    ],
  },
  {
    name: "New Delhi",
    markets: [
      {
        name: "Aerocity",
        centres: [
          { name: "Table Space Worldmark 4", href: "/locations/delhi/table-space-worldmark-4" },
        ],
      },
    ],
  },
  {
    name: "Mumbai",
    markets: [
      {
        name: "Airoli",
        centres: [
          { name: "Table Space GigaPlex", href: "/locations/mumbai/gigaplex" },
        ],
      },
      {
        name: "Andheri",
        centres: [
          { name: "Table Space R Square", href: "/locations/mumbai/r-square" },
          { name: "Table Space Solitaire Corporate Park", href: "/locations/mumbai/solitaire-corporate-park" },
        ],
      },
      {
        name: "BKC",
        centres: [
          { name: "Table Space Trent House", href: "/locations/mumbai/trent-house" },
          { name: "Table Space Godrej BKC", href: "/locations/mumbai/godrej-bkc" },
          { name: "Table Space The Capital", href: "/locations/mumbai/the-capital" },
        ],
      },
      {
        name: "Goregaon",
        centres: [
          { name: "Table Space Commerz-III", href: "/locations/mumbai/commerz-iii" },
        ],
      },
      {
        name: "Vile Parle East",
        centres: [
          { name: "Table Space The ORB", href: "/locations/mumbai/the-orb" },
        ],
      },
      {
        name: "Worli",
        centres: [
          { name: "Table Space KRC Altimus", href: "/locations/mumbai/krc-altimus" },
        ],
      },
    ],
  },
  {
    name: "Chennai",
    markets: [
      {
        name: "Perungundi",
        centres: [
          { name: "Table Space Global Infocity Park", href: "/locations/chennai/global-infocity-park" },
        ],
      },
      {
        name: "Secondary Business District",
        centres: [
          { name: "Table Space KRC Commerzone", href: "/locations/chennai/krc" },
        ],
      },
      {
        name: "Tharamani",
        centres: [
          { name: "Table Space DLF Downtown 3", href: "/locations/chennai/dlf-downtown-3" },
          { name: "Table Space DLF Downtown 1", href: "/locations/chennai/dlf-downtown-1-taramani" },
        ],
      },
    ],
  },
  {
    name: "Pune",
    markets: [
      {
        name: "Balewadi",
        centres: [
          { name: "Table Space Amar Tech Park", href: "/locations/pune/amar-tech-park" },
          { name: "Table Space Balewadi Tech Park", href: "/locations/pune/balewadi-tech-park" },
        ],
      },
      {
        name: "Kalyani Nagar",
        centres: [
          { name: "Table Space GLT Raheja Woods", href: "/locations/pune/glt" },
        ],
      },
      {
        name: "Kharadi",
        centres: [
          { name: "Table Space Godrej Yerwada", href: "/locations/pune/table-space-godrej-yerwada" },
          { name: "Table Space AP4 Tech Park", href: "/locations/pune/table-space-ap4-tech-park" },
          { name: "Table Space International Tech Park Pune (ITPP)", href: "/locations/pune/itpp" },
          { name: "Table Space World Trade Center", href: "/locations/pune/world-trade-center" },
        ],
      },
      {
        name: "Koregaon Park",
        centres: [
          { name: "Table Space Godrej Koregaon Park", href: "/locations/pune/godrej-kp" },
          { name: "Table Space ABIL Boulevard", href: "/locations/pune/abil" },
        ],
      },
      {
        name: "Shastrinagar",
        centres: [
          { name: "Table Space Tech Park One", href: "/locations/pune/tech-park-one" },
        ],
      },
      {
        name: "Viman Nagar",
        centres: [
          { name: "Table Space Panchshil Business Park", href: "/locations/pune/panchshil-vimannagar" },
          { name: "Table Space Fountain Head", href: "/locations/pune/fountain-head" },
        ],
      },
    ],
  },
];
